import React, { useState } from "react";
import { Typography, Chip, Collapse } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MemoryOutlinedIcon    from "@material-ui/icons/MemoryOutlined";
import StorageOutlinedIcon   from "@material-ui/icons/StorageOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import SwapHorizOutlinedIcon from "@material-ui/icons/SwapHorizOutlined";
import ShowChartOutlinedIcon from "@material-ui/icons/ShowChartOutlined";
import ExpandMoreIcon        from "@material-ui/icons/ExpandMore";

const BLUE        = "#3B82F6";
const BLUE_DIM2   = "rgba(59,130,246,0.14)";
const BLUE_BORDER = "rgba(59,130,246,0.25)";
const BORDER      = "#dde0ee";
const SURFACE     = "#f5f6fa";
const TEXT        = "#1a1d2e";
const MUTED       = "#7b80a0";

export const MODULES = [
  {
    key: "system_model", label: "System Model",
    Icon: MemoryOutlinedIcon,
    dotBg: BLUE_DIM2, dotColor: BLUE
  },
  {
    key: "db_profile", label: "Database Model",
    Icon: StorageOutlinedIcon,
    dotBg: "rgba(34,194,122,0.12)", dotColor: "#18a86a"
  },
  {
    key: "views", label: "Views",
    Icon: DashboardOutlinedIcon,
    dotBg: "rgba(130,80,230,0.1)", dotColor: "#8250e6"
  },
  {
    key: "transactions", label: "Transactions",
    Icon: SwapHorizOutlinedIcon,
    dotBg: "rgba(220,140,30,0.12)", dotColor: "#c07a10"
  },
  {
    key: "simulation", label: "Simulations",
    Icon: ShowChartOutlinedIcon,
    dotBg: "rgba(224,92,92,0.1)", dotColor: "#c04444"
  },
];

const useStyles = makeStyles(() => ({
  card: {
    border: `0.5px solid ${BORDER}`,
    borderRadius: 6,
    overflow: "hidden",
    background: "#fff",
    marginBottom: 7,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "9px 12px",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": { background: SURFACE },
  },
  dot: {
    width: 26,
    height: 26,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& svg": { fontSize: 15 },
  },
  name: { flex: 1, fontSize: 12, fontWeight: 600, color: TEXT },
  tag: {
    fontSize: 10,
    height: 18,
    background: BLUE_DIM2,
    color: BLUE,
    border: `0.5px solid ${BLUE_BORDER}`,
    borderRadius: 10,
    fontWeight: 500,
    marginLeft: 4,
    "& .MuiChip-label": { padding: "0 7px" },
  },
  chevron:     { color: MUTED, fontSize: 16, marginLeft: 2, transition: "transform 0.18s" },
  chevronOpen: { transform: "rotate(180deg)" },
  body: {
    padding: "9px 12px 11px 46px",
    borderTop: `0.5px solid ${BORDER}`,
    background: SURFACE,
    fontSize: 11,
    lineHeight: 1.75,
    color: MUTED,
  },
  item: { marginBottom: 1, fontSize: 11 },
}));

export default function ModuleCard({ mod, defaultOpen = false }) {
  const cls = useStyles();
  const [open, setOpen] = useState(defaultOpen);
  const { Icon } = mod;

  return (
    <div className={cls.card}>
      <div className={cls.header} onClick={() => setOpen((o) => !o)}>
        <div className={cls.dot} style={{ background: mod.dotBg }}>
          <Icon style={{ color: mod.dotColor }} />
        </div>
        <Typography className={cls.name}>{mod.label}</Typography>
        <ExpandMoreIcon className={`${cls.chevron} ${open ? cls.chevronOpen : ""}`} />
      </div>

      <Collapse in={open}>
        <div className={cls.body}>
          {!mod.content || mod.content === '' ? 'No Summary' : mod.content}
        </div>
      </Collapse>
    </div>
  );
}